/**
 * @generated SignedSource<<8d7b712f7af89c3c5f3bbd14ddd6f43f>>
 * @relayHash c5a7600018727112c4a3b649ccd48584
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53a1420b38050737a034e20c57ec8c1b8257c4bf0d17b5afe6e766619669b64e

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventHostStatus = "CONFIRMED" | "DECLINED" | "PENDING" | "%future added value";
export type AcceptEventHostInvitationInput = {
  clientMutationId?: string | null | undefined;
  pEventHostId?: string | null | undefined;
};
export type EventHostInvitationBannerAcceptMutation$variables = {
  input: AcceptEventHostInvitationInput;
};
export type EventHostInvitationBannerAcceptMutation$data = {
  readonly acceptEventHostInvitation: {
    readonly event: {
      readonly " $fragmentSpreads": FragmentRefs<"EventScreenOwner_event">;
    } | null | undefined;
    readonly eventHost: {
      readonly id: string;
      readonly status: EventHostStatus;
    } | null | undefined;
  } | null | undefined;
};
export type EventHostInvitationBannerAcceptMutation = {
  response: EventHostInvitationBannerAcceptMutation$data;
  variables: EventHostInvitationBannerAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "EventHost",
  "kind": "LinkedField",
  "name": "eventHost",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v7 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v8 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v9 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "primaryPhoto",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "transform"
              }
            ],
            "kind": "ScalarField",
            "name": "transformUrl",
            "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorPalette",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "type": "Guild",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailMd5",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "primaryPhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "fo",
                    "value": "face"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "transform"
              }
            ],
            "kind": "ScalarField",
            "name": "transformUrl",
            "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "transform"
          }
        ],
        "kind": "ScalarField",
        "name": "defaultAvatarUrl",
        "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
      }
    ],
    "type": "User",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v2/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventHostInvitationBannerAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcceptEventHostInvitationPayload",
        "kind": "LinkedField",
        "name": "acceptEventHostInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenOwner_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventHostInvitationBannerAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcceptEventHostInvitationPayload",
        "kind": "LinkedField",
        "name": "acceptEventHostInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventHostsConnection",
                "kind": "LinkedField",
                "name": "confirmedHosts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventHostsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventHost",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "host",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "53a1420b38050737a034e20c57ec8c1b8257c4bf0d17b5afe6e766619669b64e",
    "metadata": {},
    "name": "EventHostInvitationBannerAcceptMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "497eb011e75f90d0c62db85b2dcec7c8";

export default node;
